export default __webpack_public_path__ + "static/media/submission.bf0d490f.png";